import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './Text.module.scss';
import { TextProps } from './TextProps';

const Text: FC<TextProps> = ({
  bold,
  children,
  translate,
  placeholder,
  ellipsis,
  subtitle,
  italic,
}) => {
  const [trans] = useTranslation();

  return (
    <span
      className={classNames(
        styles.default,
        bold && styles.bold,
        placeholder && styles.placeholder,
        subtitle && styles.subtitle,
        ellipsis && styles.ellipsis,
        italic && styles.italic,
      )}
    >
      {/*
      // @ts-ignore */}
      {translate ? trans(children) : children}
      {!children && <em>{trans('UNKNOWN')}</em>}
    </span>
  );
};

Text.defaultProps = {
  bold: false,
  translate: false,
  placeholder: false,
  ellipsis: false,
};

export default Text;
